// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { LeanIxCard } from './LeanIxCard';

const leanixCard = EntityCardBlueprint.make({
  name: 'leanix',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { LeanIxCard } = await import('./LeanIxCard');
      return <LeanIxCard />;
    },
  },
});

export const leanixCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [leanixCard],
});
